export default __webpack_public_path__ + "static/media/icon-dropdown.73f2fc5d.svg";